import { render } from "./MainListOfAccountsReceivablePayments.vue?vue&type=template&id=eeb2dd28&scoped=true"
import script from "./MainListOfAccountsReceivablePayments.vue?vue&type=script&lang=js"
export * from "./MainListOfAccountsReceivablePayments.vue?vue&type=script&lang=js"

import "./MainListOfAccountsReceivablePayments.vue?vue&type=style&index=0&id=eeb2dd28&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeb2dd28"]])

export default __exports__